import { Flex } from "@aircall/tractor";
import { useCall } from "@/hooks/useCall/useCall";
import { useNoInformationRule } from "@/hooks/useNoInformationRule/useNoInformationRule";
import { useTrackAssetsPageOpen } from "@/hooks/useTrackAssetsPageOpen/useTrackAssetsPageOpen";
import { NoInformation } from "../NoInformation/NoInformation";
import { SectionDetails } from "../SectionDetails/SectionDetails";
import { SectionTranscript } from "../SectionTranscript/SectionTranscript";

export function Body() {
  const { call } = useCall();
  const { hasNoInformation } = useNoInformationRule();

  useTrackAssetsPageOpen();

  if (!call) {
    return null;
  }

  // A call with neither a recording nor a transcription shows the no-information
  // state in place of the transcript panel only, so Call info / Notes stay
  // reachable and the call can still be tagged (CI-6374, CI-6448).
  return (
    <Flex overflow="auto" flexGrow={1} background="#F7F7F7">
      <SectionDetails />
      {hasNoInformation ? <NoInformation /> : <SectionTranscript />}
    </Flex>
  );
}
